import { useQuery } from '@tanstack/react-query';

import missionQueries from '@carers/views/Missions/utils/missionQueryFactory';

const useGetUserTasksCount = () => useQuery(missionQueries.tasksCount());

export default useGetUserTasksCount;
